<h3>{{data.title | translate}}</h3>

<div class="inputForm">
    <mat-form-field appearance="outline">
        <mat-label>{{'DASHBOARD.FORM.LABEL_NAME'| translate}}</mat-label>
        <input maxlength="30" matInput [(ngModel)]="dashboard.name"/>
    </mat-form-field>
</div>

<button mat-raised-button [mat-dialog-close]>{{'DASHBOARD.FORM.CANCEL' | translate}}</button>
<button mat-raised-button color="primary" class="right" [disabled]="isEmpty()"
    [mat-dialog-close]="dashboard" cdkFocusInitial>{{'DASHBOARD.FORM.ACCEPT' | translate}}</button>